import React from 'react';

const HobbyFields = ({
  oldData, 
  setHobby,
  setSubjectPositive,
  setSubjectNegative,
  setSubjectTriggers
}) => {

  return (
    <>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Хобби
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.hobby}
          placeholder='Хобби'
          onChange={e => { setHobby(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Любимые темы
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.subject_positive}
          placeholder='Любимые темы'
          onChange={e => { setSubjectPositive(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Запретные темы
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.subject_negative}
          placeholder='Запретные темы'
          onChange={e => { setSubjectNegative(e) }}
      />

      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
      Триггеры (боли клиента)
      </div>

      <input
          className='main-form__input main-form__input-full'
          value={oldData.subject_triggers}
          placeholder='Триггеры (боли клиента)'
          onChange={e => { setSubjectTriggers(e) }}
      />

    </>
  );
};

export default HobbyFields;